import React, { useEffect, useState } from 'react';

import * as SP from '../styles'
import CardShopping, { IPartsCard, ISupplierCard } from '@/main/components/shared/card/cardShopping'
import InfiniteScroll from 'react-infinite-scroll-component'
import LoadingComponent from '@/main/components/shared/loading/loadingComponent'
import { PartSearchResponse } from '@/main/models/response'
import { PaginationEnum } from '@/main/services/enum/PaginationEnum'
import { partApi } from '@/main/api'
import ResultNotFoundComponent from '@/main/components/shared/resultNotFound/resultNotFoundComponent'
import { useUserReducer } from '@/main/store/user'
import HeadProductList from '@/main/components/shared/headProductList/headProductList'
import { useCreateOrderContext } from '../../../context'
import { CartPart, useCartReducer } from '@/main/store/cart'
import CardGridPart from './cardGridPart/cardGridPart';
import GridPartFactory from './gridPartFactory/gridPartFactory';

export interface IPartsGridData {
  data: PartSearchResponse[];
  totalItems: number;
  isLoading: boolean;
}
export const INITIAL_PARTS_GRID_STATE: IPartsGridData = {
  totalItems: 0,
  isLoading: false,
  data: []
};
interface IScreenPartsProps {
  partsGridData: IPartsGridData;
  formFilters: any;
  setPartsGridData: React.Dispatch<React.SetStateAction<IPartsGridData>>;
  displaySupplierParts: (
    value: string,
    externalPartId: string,
    event: React.MouseEvent<HTMLTableRowElement, MouseEvent>
  ) => void;
  handleAddCart: (part: IPartsCard, suuplier: ISupplierCard) => void;
  displayCart: () => void;
}
function ScreenParts({
  partsGridData,
  formFilters,
  setPartsGridData,
  displaySupplierParts,
  handleAddCart,
  displayCart
}: IScreenPartsProps) {
  const userReducer = useUserReducer();
  const { cartItems: cartReducer } = useCartReducer();
  const { showSupplierParts } = useCreateOrderContext();
  const [isLoadingInfiniteScroll, setIsLoadingInfiniteScroll] = useState(false);
  const [hasShowMore, setHasShowMore] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const onlyPartsCart = cartReducer.data.reduce((acc, item) => {
    if (item.parts.length > 0) {
      const { parts, ...restItem } = item;
      const formattedParts = parts.map((part) => ({
        ...part,
        supplier: {
          ...restItem
        }
      }))
      acc.push(...formattedParts)
    }
    return acc;
  }, [] as CartPart[])
  async function fetchMoreGridData(request: any) {
    setIsLoadingInfiniteScroll(true);

    partApi
      .getSearchParts(request)
      .then(response => {
        const { data: result } = response;
        const resultData =
          partsGridData.data.length > 0
            ? [...partsGridData.data, ...result.results]
            : result.results;
        const newPartsGridData = {
          data: resultData,
          totalItems: result.totalNumberOfRecords,
          isLoading: false
        };
        const resultTotalItems = result.totalNumberOfRecords;

        setPartsGridData(newPartsGridData);

        // Disable show more
        if (
          resultTotalItems < PaginationEnum.PageSize10 ||
          resultTotalItems === resultData.length
        ) {
          setHasShowMore(false);
        }
      })
      .catch(error => { })
      .finally(() => setIsLoadingInfiniteScroll(false));
  }
  function onLoadSearchGrid() {
    const updateIndex = pageIndex + PaginationEnum.PageIndexIntial;
    const formFiltersOnLoadSearchGrid = formFilters;
    setPageIndex(updateIndex);

    if (formFiltersOnLoadSearchGrid) {
      const updatedFormFilters = {
        ...formFiltersOnLoadSearchGrid,
        pageIndex: updateIndex
      };
      fetchMoreGridData(updatedFormFilters);
    }
  }

  function onLoadCartQuantity(part: PartSearchResponse) {
    const partsInCart = onlyPartsCart.filter((item) => item.guidPart === part.guid);

    if (!partsInCart || partsInCart.length === 0) return;
    if (partsInCart.length === 1) return partsInCart[0];

    const totalQuantityPart = onlyPartsCart.reduce((acc, item) => item.guidPart === part.guid ? acc + item.quantity : acc, 0);
    const formattedPartCart = {
      ...partsInCart[0],
      hasMoreSuppliers: partsInCart.length > 1,
      quantity: totalQuantityPart
    }
    return formattedPartCart;
  }

  useEffect(() => {
    setHasShowMore(partsGridData.data.length < partsGridData.totalItems);
  }, [partsGridData.data]);

  useEffect(() => {
    setPageIndex(PaginationEnum.PageIndexIntial);
  }, [formFilters]);

  if (partsGridData.isLoading) return <LoadingComponent />;
  if (partsGridData.data.length === 0)
    return <ResultNotFoundComponent styles={{ marginTop: 10 }} />;

  return (
    <InfiniteScroll
      dataLength={partsGridData.data.length}
      next={() => onLoadSearchGrid()}
      hasMore={hasShowMore && !showSupplierParts}
      loader={isLoadingInfiniteScroll ? <LoadingComponent /> : <></>}>
      <SP.BoxProductLayout>
        <SP.MainParts
          className={
            userReducer.userPreference.preferences.isViewCard
              ? 'data-layout-grid'
              : 'data-layout-column'
          }
          layoutGrid={userReducer.userPreference.preferences.isViewCard}>
          <HeadProductList />
          {partsGridData.data.map((part, index) => (
            <GridPartFactory
              key={part.guid}
              id={`id-createOrder-button-card-${part.partName}`}
              part={part}
              partInCart={onLoadCartQuantity(part)}
              onClickCart={handleAddCart}
              displayCart={displayCart}
              onClick={event => {
                displaySupplierParts(part.guid, '', event);
              }}
            />

          ))}
        </SP.MainParts>
      </SP.BoxProductLayout>
    </InfiniteScroll>
  );
}

export default ScreenParts;
